import { render } from "./WCEditItemButton.vue?vue&type=template&id=838ea7da"
import script from "./WCEditItemButton.vue?vue&type=script&lang=js"
export * from "./WCEditItemButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__